import {Injectable} from '@angular/core';
import {BootstrapData} from '@core/interfaces/bootstrap.interface';
import {API_BOOTSTRAP, getEndpoint} from '@core/constants/api';
import {ResponseObject} from '@shared/interfaces/http.interface';
import {BootstrapLicenseDataService} from '@core/services/bootstrap/bootstrap-license-data.service';
import {HttpClient} from '@angular/common/http';
import {Roles} from '@core/modules/role/enums/roles.enum';
import {TokenService} from '@core/modules/authentication/services';
import {RoleService} from '@core/modules/role/services/role.service';

@Injectable({
  providedIn: 'root'
})
export class BootstrapLicenseService {
  constructor(
    private http: HttpClient,
    private bootstrapDataService: BootstrapLicenseDataService,
    private token: TokenService,
    private role: RoleService,
  ) {}

  getBootstrapLicense(): Promise<void> {
    // Sprawdzamy licencję tylko dla zalogowanych, poza kontem administratora.
    // Zwracany funkcję, której wynikiem jest promise, aby aplikacja zawsze się uruchomiła (bootstrap - APP_INITIALIZER).
    // W przeciwnym razie, w przypadku reject'a, aplikacja nie zostałaby zainicjowana.
    if (this.token.isToken && !this.role.isRole(Roles.Admin)) {
      this.bootstrapDataService.resetBootstrapLicenseData();

      return this.http.get<ResponseObject<BootstrapData>>(getEndpoint(API_BOOTSTRAP)).toPromise()
        .then((response) => this.bootstrapDataService.setBootstrapData(response.data))
        .catch(() => this.bootstrapDataService.setBootstrapError(true));
    }
    return Promise.resolve();
  }
}
